import { Component } from '@angular/core';

@Component({
  selector: 'app-sed-events-distribution',
  templateUrl: './sed-events-distribution.component.html',
  styleUrl: './sed-events-distribution.component.scss',
  standalone: false,
})
export class SedEventsDistributionComponent {}
